import { render } from "./PageDetail.vue?vue&type=template&id=07f118e6&scoped=true"
import script from "./PageDetail.vue?vue&type=script&lang=js"
export * from "./PageDetail.vue?vue&type=script&lang=js"

import "./PageDetail.vue?vue&type=style&index=0&id=07f118e6&scoped=true&lang=css"

import exportComponent from "/Volumes/Evolve/WorkSpace/MinonowaRadio/Ver2/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f118e6"]])

export default __exports__